// Service d'authentification sécurisé avec fonctions
const TOKEN_KEY = 'admin_token';
const EXPIRY_KEY = 'admin_expiry';
const TOKEN_DURATION = 24 * 60 * 60 * 1000; // 24 heures en millisecondes

// Générer un token sécurisé
const generateToken = () => {
  const timestamp = Date.now();
  const random = Math.random().toString(36).substring(2);
  const secret = 'solarenov-grp-2026-sec-key';
  
  // Créer un token basé sur timestamp + random + secret
  const tokenData = `${timestamp}-${random}-${secret}`;
  const token = btoa(tokenData); // Encoder en base64
  
  return {
    token,
    expiresAt: timestamp + TOKEN_DURATION
  };
};

// Vérifier si le token est valide
const isValidToken = (token) => {
  try {
    const decoded = atob(token);
    const [timestamp, random, secret] = decoded.split('-');
    
    // Vérifier le secret
    if (secret !== 'solarenov-grp-2026-sec-key') {
      return false;
    }
    
    // Vérifier l'expiration
    const tokenTime = parseInt(timestamp);
    const now = Date.now();
    
    return now < tokenTime + TOKEN_DURATION;
  } catch (error) {
    return false;
  }
};

// Se connecter avec mot de passe
const login = (password) => {
  const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
  
  if (password === ADMIN_PASSWORD) {
    const { token, expiresAt } = generateToken();
    
    // Stocker le token et l'expiration
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(EXPIRY_KEY, expiresAt.toString());
    
    return {
      success: true,
      token,
      expiresAt: new Date(expiresAt)
    };
  }
  
  return {
    success: false,
    error: 'Mot de passe incorrect'
  };
};

// Vérifier si l'utilisateur est connecté
const isAuthenticated = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiry = localStorage.getItem(EXPIRY_KEY);
  
  if (!token || !expiry) {
    return false;
  }
  
  // Vérifier si le token n'a pas expiré
  const now = Date.now();
  const expiryTime = parseInt(expiry);
  
  if (now >= expiryTime) {
    logout();
    return false;
  }
  
  // Vérifier la validité du token
  return isValidToken(token);
};

// Se déconnecter
const logout = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRY_KEY);
};

// Obtenir les informations du token
const getTokenInfo = () => {
  const token = localStorage.getItem(TOKEN_KEY);
  const expiry = localStorage.getItem(EXPIRY_KEY);
  
  if (!token || !expiry) {
    return null;
  }
  
  return {
    token,
    expiresAt: new Date(parseInt(expiry)),
    isValid: isAuthenticated()
  };
};

// Renouveler le token
const refreshToken = () => {
  if (isAuthenticated()) {
    const { token, expiresAt } = generateToken();
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(EXPIRY_KEY, expiresAt.toString());
    return true;
  }
  return false;
};

// Export des fonctions
export default {
  login,
  isAuthenticated,
  logout,
  getTokenInfo,
  refreshToken
};
